import { render, staticRenderFns } from "./DocPropsTable.vue?vue&type=template&id=ada2b51a"
import script from "./DocPropsTable.vue?vue&type=script&lang=js"
export * from "./DocPropsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports